import MBusinessHourSettingItem from './index.vue';

MBusinessHourSettingItem.install = app => {
  app.component(MBusinessHourSettingItem.name, MBusinessHourSettingItem);
};

export default MBusinessHourSettingItem;
